
import { zonedTimeToUtc } from 'date-fns-tz';
import { apiurl } from './constants';
import { getSolpedApprovalValidation, isSolpedService } from './solpedApproval';

export { getSolpedApprovalValidation };

// Zona horaria del navegador (el backend guarda las fechas en UTC).
export const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Convierte un día local (elegido por el usuario) a su equivalente UTC listo
 * para un WHERE de SQL: 'yyyy-MM-dd HH:mm:ss'.
 * @param {string} day  Fecha local 'YYYY-MM-DD' (p.ej. de un <input type="date">).
 * @param {string} time Hora local 'HH:mm:ss'. Por defecto '00:00:00'.
 * @param {string} tz   Zona horaria de origen. Por defecto la del navegador.
 * @returns {string} Fecha/hora en UTC 'yyyy-MM-dd HH:mm:ss', o '' si no hay day.
 */
export const localDateToUtcSql = (day, time = '00:00:00', tz = BROWSER_TZ) =>
	day ? zonedTimeToUtc(`${day}T${time}`, tz).toISOString().slice(0, 19).replace('T', ' ') : '';

export const setFiltDate = (valDate, type = 'start') => {
	const newVal = new Date(valDate);
	if (type === 'start') newVal.setHours(0, 0, 0, 0);
	else newVal.setHours(23, 59, 59, 999);
	newVal.setDate(newVal.getDate() + 1);
	return newVal;
}

export const fetchData = async (endpoint, query, mail) => {
	try {
		console.log(apiurl + endpoint, { query, user: mail });

		const response = await fetch(apiurl + endpoint, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
			body: JSON.stringify({ query, user: mail }),
		});

		if (response.ok) {
			const data = await response.json();
			return data.length > 0 ? data : null;
		} else {
			throw new Error('Error en la solicitud POST');
		}
	} catch (error) {
		console.error('Error:', error);
		return null;
	}
};

export const postData = async (endpoint, payload) => {
	try {
		const response = await fetch(apiurl + endpoint, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
			body: JSON.stringify(payload),
		});

		if (response.ok) {
			const data = await response.json();
			return data ? data : null;
		} else {
			throw new Error('Error en la solicitud POST');
		}
	} catch (error) {
		console.error('Error:', error);
		return null;
	}
};

export const log = async (acti, modu, affe, user, iuser, data = null, sapDB = null) => {
	try {
		const response = await fetch(apiurl + 'log', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				acti: acti,
				modu: modu,
				affe: affe,
				data: data,
				user: user,
				iuser: iuser,
				sapDB: sapDB
			})
		});

		if (response.ok) {
			const data = await response.json();
			return data.length > 0 ? data : null;
		} else {
			return null;
		}

	} catch (error) {
		console.error('Error:', error);
		return null;
	}
}

export const sendMail = async (to, subject, mensaje) => {
	try {

		const response = await fetch(apiurl + 'sendMail', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				to: to,
				subject: subject,
				html: mensaje
			})
		});
		if (response.ok) {
			const data = await response.json();
			return data.length > 0 ? data : null;
		} else {
			throw new Error('Error sendMail');
		}
	} catch (error) {
		console.error('Error en la solicitud:', error);
		return null;
	}
}

export const fCurr = (value) => {
	return new Intl.NumberFormat('es-CL', {
		currency: 'CLP',
	}).format(value);
};


export const isService = isSolpedService;


export const getCurrentDateTime = () => {
	const now = new Date();
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	const day = String(now.getDate()).padStart(2, '0');

	return `${day}/${month}/${year}`;
};

export const approveSolped = async (solp, iden, mail, sapDB, from = 'web') => {
	let ordByCost = [];

	const searchApproverForTotalCost = async () => {

		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					sapDB: sapDB,
					query: `SELECT 
							(SELECT CASE WHEN (SELECT SUM(cost*amou) FROM req__item WHERE soli=${solp}) < ord1 THEN 1 WHEN (SELECT SUM(cost*amou) FROM req__item WHERE soli=${solp}) < ord2 THEN 2 ELSE 3 END FROM req__tier) ord,
							(SELECT user FROM req__appr WHERE soli=${solp}) as appr,
							(SELECT approver FROM req__auth WHERE soli=${solp} AND level=1) as hasLvl1,
							(SELECT approver FROM req__auth WHERE soli=${solp} AND level=2) as hasLvl2,
							(SELECT approver FROM req__auth WHERE soli=${solp} AND level=3) as hasLvl3,    
							(SELECT mail FROM sys__user WHERE iden = (SELECT user FROM req__appr WHERE soli=${solp}) ) AS appr_mail,
							(SELECT mail FROM sys__user WHERE iden = (SELECT requester FROM req__soli WHERE iden=${solp}) ) AS mail_requ,
							(SELECT GROUP_CONCAT(DISTINCT userOrd1.mail) 
								FROM req__cent cent LEFT JOIN sys__link linkOrd1 ON cent.ord1 = linkOrd1.posi LEFT JOIN sys__user userOrd1 ON linkOrd1.user = userOrd1.iden 
								WHERE code = (SELECT cent FROM req__soli WHERE iden=${solp}) GROUP BY code
							) AS mail,
							(SELECT GROUP_CONCAT(DISTINCT userOrd2.mail) 
								FROM req__cent cent LEFT JOIN sys__link linkOrd2 ON cent.ord2 = linkOrd2.posi LEFT JOIN sys__user userOrd2 ON linkOrd2.user = userOrd2.iden 
								WHERE code = (SELECT cent FROM req__soli WHERE iden=${solp}) GROUP BY code
							) AS mail2,
							(SELECT GROUP_CONCAT(DISTINCT userOrd3.mail) 
								FROM req__cent cent LEFT JOIN sys__link linkOrd3 ON cent.ord3 = linkOrd3.posi LEFT JOIN sys__user userOrd3 ON linkOrd3.user = userOrd3.iden 
								WHERE code = (SELECT cent FROM req__soli WHERE iden=${solp}) GROUP BY code
							) AS mail3, ( SELECT MD5(CONCAT('BailacORM',${solp})) ) share`
				})
			});

			if (response.ok) {
				const data = await response.json();
				ordByCost = data[0];
				let stat = await approverForLevel();
				return stat;
			}

		} catch (error) {
			console.error('Error en la searchApproversForTotalCost:', error);
			return 1;
		}
	}

	const approverForLevel = async () => {
		try {
			if ((ordByCost.ord === 1 ||  ordByCost.ord === '1') && !ordByCost.hasLvl1) {
				if (ordByCost.mail && ordByCost.mail.split(",").includes(mail)) return await sendAprobSap(1);
				else return 3;
			}

			else if (ordByCost.ord === 2 || ordByCost.ord === '2') {

				if (!ordByCost.hasLvl1) {

					if (ordByCost.mail2.split(",").includes(mail)) {
						await insertReqAuthByLvl(1, false);
						return await sendAprobSap(2);
					}
					else return await insertReqAuthByLvl(1);
				}
				else if (ordByCost.hasLvl1 && !ordByCost.hasLvl2 && ordByCost.mail2.split(",").includes(mail)) { return await sendAprobSap(2); }
				else return 3;
			} else if (ordByCost.ord === 3 || ordByCost.ord === '3') {

				if (!ordByCost.hasLvl1) {

					if (ordByCost.mail2.split(",").includes(mail)) {
						await insertReqAuthByLvl(1, false);
						return await insertReqAuthByLvl(2);
					}
					else return await insertReqAuthByLvl(1);
				}
				else if (!ordByCost.hasLvl2) {
					if (ordByCost.mail3.split(",").includes(mail)) {
						await insertReqAuthByLvl(2, false);
						return await sendAprobSap(3);
					}
					else return await insertReqAuthByLvl(2);
				}
				else if (ordByCost.hasLvl1 && ordByCost.hasLvl2 && !ordByCost.hasLvl3 && ordByCost.mail3.split(",").includes(mail)) return await sendAprobSap(3);
				else return 3;
			} else {
				console.log(`Error al aprobar por lvl`);
				return 1;
			}

		} catch (error) {
			console.error('Error en la solicitud:', error);
			throw error;

		}
	}

	const sendAprobSap = async (lvl) => {
		try {
			const response = await fetch(apiurl + 'sapRequest', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'include',
				body: JSON.stringify({ solp: solp, user: mail, sapDB: sapDB, iuser: iden }),
			});
			if (response.ok) {
				const dataSAP = await response.json();
				if (dataSAP.stat === -1 || dataSAP.stat === '-1') {
					alert('Error en ORM\n ' + dataSAP.msg);
				} else if (dataSAP.stat) {

					if (dataSAP.msg.indexOf('Date deviates from permissible range') !== -1) {
						alert(dataSAP.msg + '\nError obteniendo respuesta de SAP\nLa fecha de hoy esta fuera de los rangos definidos en SAP.\nsolicite que se amplien los rangos para incluir la fecha de hoy.');
					} else if (dataSAP.msg.indexOf('Update the exchange rate') !== -1) {
						alert(dataSAP.msg + '\nError obteniendo respuesta de SAP\nNo hay tipo de cambio definido en SAP para hoy,\nsolicite que se defina un tipo de cambio.');
					} else if (dataSAP.msg.indexOf('inactive') !== -1) {
						alert(dataSAP.msg + '\nError obteniendo respuesta de SAP\nEste artículo está inactivo,\nsolicite su activación para poder solicitarlo.');
					} else {
						alert(dataSAP.msg + '\nError obteniendo respuesta de SAP');
					}
				} else if (dataSAP.message) {

					try {
						const response = await fetch(apiurl + 'tablePUT', {
							method: 'POST',
							credentials: 'include',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({
								user: mail,
								sapDB: sapDB,
								table: `req__soli`,
								fields: `approver = ${iden},approved = now()`,
								iden: `iden = ${solp}`
							})
						});

						if (response.ok) {
							log('mod', 'soli', solp, mail, iden, `approved via ${from}`, sapDB);
							return await insertReqAuthByLvl(lvl);
						} else {
							console.error('Error al obtener los CC');
						}
					} catch (error) {
						console.error('Error en la solicitud:', error);
						throw error;
					}
				}

			}
			return 1;
		} catch (error) {
			console.error('Error:', error);
			throw error;
		}

	}

	const insertReqAuthByLvl = async (lvl, send = true) => {
		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					sapDB: sapDB,
					query: `INSERT INTO req__auth (soli, level, approved, approver) VALUES (${solp}, ${lvl}, now(), ${iden})`
				})
			})

			if (response.ok) {
				if (send) await sendMailByLvl(lvl);
				return 2;
			} else {
				console.error('Error en insertReqAuthByLvl');
				return 1;
			}
		} catch (error) {
			console.error('Error en insertReqAuthByLvl:', error);
			throw error;
		}
	};

	const sendMailByLvl = async (lvl) => {
		const currentUrl = window.location.origin;
		let to, subj, mess, tablaHTML, ormshare;

		if (lvl !== ordByCost.ord) {
			to = (lvl === 1 ? ordByCost.mail2 : (lvl === 2 ? ordByCost.mail3 : null));
			// subj = `La solicitud de pedido ${solp} requiere su aprobación.`
			if (to) {

				try {
					const response = await fetch(apiurl + 'queryAux', {
						method: 'POST',
						credentials: 'include',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({
							user: mail,
							query: `SELECT inv.name, req.amou, req.cost, req.item, 
									MD5(CONCAT('BailacORM',${solp})) share,
									MD5(CONCAT('orm',${solp})) ormshare
									FROM req__item req
									INNER JOIN inv__item inv ON inv.code=req.item
									WHERE soli=${solp}`
						})
					});

					if (response.ok) {
						const data = await response.json();

						ormshare = data[0].ormshare;
						tablaHTML = `
							<table style="border-collapse: collapse; width: 50%;">
								<tbody>
								${data.map(item => `
									<tr>
										<td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${item.name}</td>
										<td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${item.amou}</td>
									</tr>
								`).join('')}
								</tbody>
							</table>
						`;

					} else {
						console.error('Error al obtener los CC');
					}
				} catch (error) {
					console.error('Error en la solicitud:', error);
				}

			}

			subj = `Se ha generado una solicitud por su centro de costo.`
			mess = `La solicitud de pedido ${solp}, requiere su aprobación.
					<br><br>
					${tablaHTML}
					<br>
					Puede ver la solicitud aquí: ${currentUrl}?db=${sapDB}&sp=${ordByCost.share}
					<br><br>
					Puede aprobar esta solicitud <a href=${currentUrl}?db=${sapDB}&approve=${to}&orm=${ormshare}>aquí</a>.
					<br><br>`;
		} else {
			to = (lvl === 1 ? (ordByCost.appr_mail ?? ordByCost.mail) : (lvl === 2 ? ordByCost.mail2 : ordByCost.mail3)) + `, ${ordByCost.mail_requ}`;
			subj = `La solicitud de pedido ${solp} ha sido aprobada.`
			mess = `Se ha aprobado la solicitud de pedido ${solp}.<br><br>Puede ver la solicitud aquí: ${currentUrl}?db=${sapDB}&sp=${ordByCost.share}`;
		}

		if (to) {
			await sendMail(to, subj, mess)
		}
	}


	return await searchApproverForTotalCost();


}

export const apiTokenSap = async (sapDB) => {
	try {
		const response = await fetch(apiurl + 'sapLoginWeb', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ sapDB: sapDB })
		});

		if (response.ok) {
			const data = await response.json();
			return data.token;
		}

	} catch (error) {
		console.error('Error en la solicitud:', error);
		throw error;
	}
}

export const getEmailsParticipantsInSolped = async (mail, solp) => {
	try {
		const response = await fetch(apiurl + 'queryAux', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				user: mail,
				query: `SELECT 
							submitter_user.mail AS mail_submitter,
							requester_user.mail AS mail_requester,
							approver_user.mail AS mail_approver,
							appr_user.mail AS mail_appr,
							requester_user.mail AS mail_requ,
							GROUP_CONCAT(DISTINCT userOrd1.mail) AS mail_lvl1,
							GROUP_CONCAT(DISTINCT userOrd2.mail) AS mail_lvl2,
							GROUP_CONCAT(DISTINCT userOrd3.mail) AS mail_lvl3,
							MD5(CONCAT('BailacORM',${solp})) AS share
						FROM req__soli soli
						LEFT JOIN sys__user submitter_user ON soli.submitter = submitter_user.iden
						LEFT JOIN sys__user requester_user ON soli.requester = requester_user.iden
						LEFT JOIN sys__user approver_user ON soli.approver = approver_user.iden
						LEFT JOIN req__appr appr ON appr.soli = soli.iden
						LEFT JOIN sys__user appr_user ON appr.user = appr_user.iden
						LEFT JOIN req__cent cent ON cent.code = soli.cent
						LEFT JOIN sys__link linkOrd1 ON cent.ord1 = linkOrd1.posi
						LEFT JOIN sys__user userOrd1 ON linkOrd1.user = userOrd1.iden
						LEFT JOIN sys__link linkOrd2 ON cent.ord2 = linkOrd2.posi
						LEFT JOIN sys__user userOrd2 ON linkOrd2.user = userOrd2.iden
						LEFT JOIN sys__link linkOrd3 ON cent.ord3 = linkOrd3.posi
						LEFT JOIN sys__user userOrd3 ON linkOrd3.user = userOrd3.iden
						WHERE soli.iden = ${solp}
						GROUP BY soli.iden;`
			}),
		});

		if (response.ok) {
			const data = await response.json();

			let emails = [];
			let share = '';

			data.forEach((row) => {
				if (row.share) {
					share = row.share;
				}

				for (let key in row) {
					if (key !== 'share' && row[key]) {
						emails.push(...row[key].split(','));
					}
				}
			});

			const uniqueEmails = [...new Set(emails.map(email => email.trim()).filter(email => email))];

			return { emails: uniqueEmails.join(', '), share };
		} else {
			throw new Error('Error en la solicitud POST');
		}
	} catch (error) {
		console.error('Error en la solicitud:', error);
		throw error;
	}
};

export const getEmailsParticipantsInBill = async (mail, idenForm) => {
	try {
		const response = await fetch(apiurl + 'queryAux', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				user: mail,
				query: `
				SELECT GROUP_CONCAT(DISTINCT email) AS emails
					FROM (
								
					    -- Correos de autores de posts
					    SELECT author_user.mail AS email
					    FROM bil__post bill_post
					    LEFT JOIN sys__user author_user
					        ON author_user.iden = bill_post.auth
					    WHERE bill_post.iden_form = ${idenForm}
					        AND bill_post.note = 0
					        AND author_user.mail IS NOT NULL
								
					    UNION
								
					    -- Correo del approver
					    SELECT approver_user.mail AS email
					    FROM bil__form bil_form
					    LEFT JOIN sys__user approver_user
					        ON approver_user.iden = bil_form.approver
					    WHERE bil_form.iden = ${idenForm}
					        AND approver_user.mail IS NOT NULL
								
					    UNION
								
					    -- Correo del usuario SAP
					    SELECT sap_user.mail AS email
					    FROM bil__form bil_form
					    LEFT JOIN ormsys__user sap_user
					        ON sap_user.sap_user = bil_form.UserCode
					    WHERE bil_form.iden = ${idenForm}
					        AND sap_user.mail IS NOT NULL
								
					) mails;
				`
			}),
		});

		if (response.ok) {
			const data = await response.json();
			const emails = String(data?.[0]?.emails ?? '')
				.split(',')
				.map((entry) => entry.trim())
				.filter(Boolean);

			const uniqueEmails = [...new Set(emails)];
			return { emails: uniqueEmails.join(', ') };
		} else {
			throw new Error('Error en la solicitud POST');
		}
	} catch (error) {
		console.error('Error en la solicitud:', error);
		throw error;
	}
};

export const loginORMbyGoogle = async (userObject) => {

	try {
		const response = await fetch(apiurl + 'login', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
			body: JSON.stringify({ mail: userObject.email, role: 0, name: userObject.given_name + ' ' + userObject.family_name, avat: userObject.picture }),
		});

		const data = await response.json();
		if (response.ok) {
			return data.user;
		}
		throw new Error(data.message);
	} catch (error) {
		return { error: error.message };
	}
};

export const loginORMbyCookie = async (mail) => {

	try {
		console.log('apiurl desde functions', apiurl);
		const response = await fetch(apiurl + 'queryAux', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			credentials: 'include',
			body: JSON.stringify({ user: mail, query: `SELECT sys__user.*, sapDB FROM sys__user LEFT JOIN sys__db ON sys__db.iden=sys__user.comp WHERE mail='${mail}'` }),
		});

		const data = await response.json();
		if (response.ok) {
			return data[0];
		}
		throw new Error(data.message);
	} catch (error) {
		return { error: error.message };
	}
};


export function getInvoiceStatusInfo(status) {
	if (status === "C" || status === "Closed") {
		return { title: "Cerrada", color: "gra" };
	}
	else if (status === "Issued") {
		return { title: "Emitida", color: "ora" };
	}
	else if (status === "Draft") {
		return { title: "Borrador", color: "gra" };
	}
	else if (status === "Cancelled") {
		return { title: "Cancelada", color: "gra" };
	}
	else if (status === "Approved") {
		return { title: "Aprobada", color: "gre" };
	}
	else if (status === "Rejected") {
		return { title: "Rechazada", color: "red" };
	}
	else if (status === "Paid") {
		return { title: "Pagada", color: "blu" };
	}
	else {
		return { title: "Contabilizada", color: "yel" };
	}
}


export function getDaysUntilDue(dueDateStr) {
	if (!dueDateStr) return null;
	const dueDate = new Date(dueDateStr);
	const today = new Date();
	return Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
}
